import { createFileRoute, redirect } from '@tanstack/react-router';

import { SavingsReportPage } from '@/areas/market-insights/MarketInsights/pages/SavingsReportPage';
import { canViewSavingsReport } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

// The report needs its flag or a non-production environment; the monitoring layout (`monitoring/route.tsx`) checks
// the rest.
export const Route = createFileRoute('/_authenticated/monitoring/_sidebar/reports/savings')({
    staticData: { access: { permissions: canViewSavingsReport }, chrome: 'none' } satisfies PageStaticData,
    beforeLoad: ({ context }) => {
        if (context.session.isFeatureFlagEnabled('redirect_savings_report_to_component_pricing')) {
            throw redirect({ to: '/monitoring/components/pricing', replace: true, search: true });
        }
    },
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <SavingsReportPage />;
}
